import api from "api";
import { AUTH_USER } from "constants/AuthConstant";
import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [authUser, setAuthUser] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem(AUTH_USER));
        } catch {
            return null;
        }
    });
    const [user, setUser] = useState(null);

    useEffect(() => {
        let didCancel = false;

        const fetchUserData = async () => {
            if (!authUser?.id) {
                setUser(null);
                return;
            }

            try {
                const response = await api.get(`/user/show/${authUser.id}`);
                if (didCancel) return;

                const result = response.data;
                const userData = result.user;
                const permissions = userData.roles?.flatMap(role =>
                    role.permissions?.map(p => p.name)
                ) || [];

                userData.permissions = permissions;
                setUser(userData);
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };

        fetchUserData();

        return () => {
            didCancel = true;
        };
    }, [authUser?.id]);

    // Add function to update authUser from outside (login component)
    const updateAuthUser = (newAuthUser) => {
        setAuthUser(newAuthUser);
    };

    const hasPermission = (permission) => {
        return user?.permissions?.includes(permission);
    };

    return (
        <AuthContext.Provider value={{ user, hasPermission, updateAuthUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;
export const useAuth = () => useContext(AuthContext);